import type { Encoding } from '@studio/js-utils/time';
import Bezier from 'bezier-easing';

/** Easing function. */
export const Easing = Bezier(0, 0.4, 0.75, 1);

/** Maximum wheel speed in `px/ms`. */
export const MaxSpeed = 15;

/** Reset delay. */
export const ResetDelay: Encoding.MILLISECONDS = 300;

/** Rolling EMA window length. */
export const WindowLength = 25;
